import { faClipboard } from '@fortawesome/pro-regular-svg-icons/faClipboard'
import { faClipboardCheck } from '@fortawesome/pro-regular-svg-icons/faClipboardCheck'
import { ActionIcon, Grid, Select, TextInput } from '@mantine/core'
import { useClipboard } from '@mantine/hooks'
import { useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { Icon, Modal } from '@flecto/ui'

function WithClipboardText({ value, label }: { value: string; label: string }) {
  const { copied, copy } = useClipboard({ timeout: 600 })
  return (
    <TextInput
      readOnly
      rightSection={
        <ActionIcon onClick={() => copy(value)} size='sm'>
          <Icon icon={copied ? faClipboardCheck : faClipboard} />
        </ActionIcon>
      }
      label={label}
      defaultValue={value}
    />
  )
}

export function ModalStoreCustomDomain() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_store' })
  const selectDomainMode = [
    {
      value: 'record',
      label: t('modal_custom_domain.label_option_a_record'),
    },
    {
      value: 'nameserver',
      label: t('modal_custom_domain.label_option_nameservers'),
    },
  ]
  const [domainMode, setDomainMode] = useState(selectDomainMode[0].value)

  return (
    <Modal size='lg'>
      <Modal.Close />
      <Modal.Title>{t('modal_custom_domain.title')}</Modal.Title>
      <Modal.Subtitle>{t('modal_custom_domain.description')}</Modal.Subtitle>
      <Modal.Content>
        <Grid>
          <Grid.Col span={4.5}>
            <Select
              label={t('modal_custom_domain.label_option')}
              value={domainMode}
              data={selectDomainMode}
              onChange={(value) => value && setDomainMode(value)}
            />
          </Grid.Col>
          {domainMode === 'record' && (
            <>
              <Grid.Col span={2}>
                <WithClipboardText
                  label={t('modal_custom_domain.label_type')}
                  value='A'
                />
              </Grid.Col>
              <Grid.Col span={2}>
                <WithClipboardText
                  label={t('modal_custom_domain.label_name')}
                  value='@'
                />
              </Grid.Col>
              <Grid.Col span={3.5}>
                <WithClipboardText
                  label={t('modal_custom_domain.label_value')}
                  value='76.76.21.21'
                />
              </Grid.Col>
            </>
          )}
          {domainMode === 'nameserver' && (
            <>
              <Grid.Col span={3.5}>
                <WithClipboardText
                  label='Nameserver 1'
                  value='ns1.vercel-dns.com'
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <WithClipboardText
                  label='Nameserver 2'
                  value='ns2.vercel-dns.com'
                />
              </Grid.Col>
            </>
          )}
        </Grid>
      </Modal.Content>
      <Modal.Cancel>{t('modal_custom_domain.label_close')}</Modal.Cancel>
    </Modal>
  )
}
